import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'; // Assuming you're using Redux for state management
import acmeHealthLogo from '../../assets/images/logo/acme_health_new_logo_2.png';
// import logout from "../../assets/images/logo/logout.png";
import FeatherIcon from 'feather-icons-react';
import { profileUsersDetailsGet } from 'apiServices';
import { NotificationsGet, notificationsRead, NotificationsReadAll } from 'apiServices/reducer/apiService';
import avtarimage from '../../assets/images/logo/default-user.jpg';
import { Bell } from "lucide-react";
import { styled } from '@mui/material/styles';
import { Badge, Menu, MenuItem, ListItemText, Button, IconButton } from '@mui/material';
import NotificationActionApproveReject from '../NotificationActionApproveReject'; // Import the modal component
import PasskeyPostLoginPrompt from '../passkey/PasskeyPostLoginPrompt';
import { ChangePassword } from 'pageComponents';
import Tooltip from '@mui/material/Tooltip';
// Add this CSS for blinking bell (can be moved to a CSS file)
const bellBlinkStyle = `
@keyframes bell-blink {
  0% { 
    color: var(--pmr-text-dark); 
    fill: none;
  }
  50% { 
    color: var(--pmr-danger); 
    fill: var(--pmr-danger);
  }
  100% { 
    color: var(--pmr-text-dark); 
    fill: none;
  }
}
.blinking {
  animation: bell-blink 1s infinite;
}
.dropdown-user-link::after,
.custom-dropdown-toggle::after {
  display: none !important;
}
  body {
    overflow-y: auto !important;
  }
.dropdown-user-link,
.custom-dropdown-toggle {
  position: relative;
}
.dropdown-user-link::before,
.custom-dropdown-toggle::before {
  display: none !important;
}
.dropdown-user {
  position: relative;
}
.dropdown-user .dropdown-menu {
  overflow: hidden;
  left: auto !important;
  right: 0 !important;
  top: calc(100% + 6px) !important;
  inset: auto 0 auto auto !important;
  transform: none !important;
  min-width: 220px;
  width: max-content;
  max-width: min(280px, calc(100vw - 16px));
}
.dropdown-user .dropdown-item:first-child:hover,
.dropdown-user .dropdown-item:first-child:focus {
  box-shadow: 0 calc(-1 * var(--bs-dropdown-padding-y, 0.5rem)) 0 0 var(--pmr-bg-subtle);
}
.dropdown-user .dropdown-item:last-child:hover,
.dropdown-user .dropdown-item:last-child:focus {
  box-shadow: 0 var(--bs-dropdown-padding-y, 0.5rem) 0 0 var(--pmr-bg-subtle);
}
.dropdown-user .dropdown-divider {
  margin: 0 !important;
}
.custom-dropdown-toggle {
  background: none !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.notification-scroll-list {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden !important;
  -webkit-overflow-scrolling: touch;
}
.notification-scroll-list .ps__rail-x,
.notification-scroll-list .ps__thumb-x {
  display: none !important;
  height: 0 !important;
}
`;

const TopHeader = (props) => {
  const [userProfile, setUserProfile] = useState({
    first_name: '',
    last_name: '',
    image_path: avtarimage
  });
  const [notifications, setNotifications] = useState({
    systemMessages: [],
    messages: [],
    importantMessages: []
  });
  const [unreadCount, setUnreadCount] = useState(0);
  const [anchorElImportant, setAnchorElImportant] = useState(null);
  const [anchorElRegular, setAnchorElRegular] = useState(null);
  const [showImportantModal, setShowImportantModal] = useState(false);
  const [selectedImportantNotification, setSelectedImportantNotification] = useState(null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get both user data types
  const userData = useSelector((state) => state.apiService.login);
  const accessType = useSelector((state) => state.apiService.sharedReportsValidateCode);

  // Determine which data to use based on access type
  const isExternalUser = accessType?.is_external_user || false;
  const activeUserData = isExternalUser ? accessType : userData;

  // Get token and user_id from the appropriate source
  const token = activeUserData?.Token || '';
  const userId = activeUserData?.user_id;

  const params = {
    token: token,
    user_id: userId
  };

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      backgroundColor: '#ef4444',
      color: '#ef4444',
      minWidth: '20px',
      height: '20px',
      padding: '0 4px',
      borderRadius: '50%',
    },
  }));
  useEffect(() => {
    const handleUpdate = () => {
      fetchNotifications();
    };

    const handleProfileNameUpdate = (event) => {
      const { first_name, last_name, image_path } = event.detail;
      setUserProfile(prev => ({
        ...prev,
        first_name: first_name || prev.first_name,
        last_name: last_name || prev.last_name,
        image_path: image_path || prev.image_path
      }));
    };

    document.addEventListener('notificationsUpdated', handleUpdate);
    document.addEventListener('profileNameUpdated', handleProfileNameUpdate);

    if (isExternalUser && accessType) {
      // For shared access users, set profile directly from accessType data
      setUserProfile({
        first_name: accessType.first_name || '',
        last_name: accessType.last_name || '',
        image_path: accessType.image_path || avtarimage
      });
      fetchNotifications();
    } else if (token && userId) {
      // For regular users, fetch profile data
      dispatch(profileUsersDetailsGet(params))
        .then((response) => {

          if (response.payload && response.payload.Table && response.payload.Table.length > 0) {
            const userDetails = response.payload.Table[0];
            setUserProfile({
              first_name: userDetails.first_name || '',
              last_name: userDetails.last_name || '',
              image_path: userDetails.Image_path || avtarimage
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching user details:", error);
          setUserProfile({
            first_name: '',
            last_name: '',
            image_path: avtarimage
          });
        });

      // Only fetch notifications for non-external users
      if (!isExternalUser) {
        fetchNotifications();
      }
    }
    return () => {
      document.removeEventListener('notificationsUpdated', handleUpdate);
      document.removeEventListener('profileNameUpdated', handleProfileNameUpdate);
    };
  }, [token, userId, isExternalUser, accessType]);

  const fetchNotifications = () => {
    if (userId && token) {
      dispatch(NotificationsGet({ user_id: userId, token }))
        .then((resp) => {
          const notifArr = Array.isArray(resp.payload) ? resp.payload : resp.payload?.Table;
          if (notifArr && notifArr.length > 0) {
            // Only family account notifications and specific request notifications should be in important notifications
            // Regular shared reports should go to regular notifications
            const importantMessages = notifArr.filter(m => {
              // Family account notifications
              const isFamilyAccount = m.family_account_id && m.approved_yn === null;

              // Request notifications (like "A request has been raised for accessing your reports")
              const isRequestNotification = m.share_id && m.approved_yn === null &&
                m.comments && m.comments.includes('request has been raised');

              // Approved/rejected notifications (approved_yn === true or false)
              const isApprovedRejected = m.share_id && (m.approved_yn === true || m.approved_yn === false);

              // Family member request notifications - check for family_account_id and specific notification types
              const isFamilyMemberRequest = m.family_account_id &&
                (m.approved_yn === null || m.approved_yn === true || m.approved_yn === false);

              return isFamilyAccount || isRequestNotification || isApprovedRejected || isFamilyMemberRequest;
            });

            const importantNotificationIds = new Set(importantMessages.map(m => m.notification_id));

            // All other shared reports and messages go to regular notifications
            const messages = notifArr.filter(m =>
              (m.site_id || m.share_id || m.family_account_id) && !importantNotificationIds.has(m.notification_id)
            );

            const systemMessages = notifArr.filter(m =>
              !m.site_id && !m.share_id && !m.family_account_id && !importantNotificationIds.has(m.notification_id)
            );

            setNotifications({ systemMessages, messages, importantMessages });
            setUnreadCount(
              systemMessages.filter(m => !m.is_displayed).length +
              messages.filter(m => !m.is_displayed).length +
              importantMessages.filter(m => !m.is_displayed).length
            );
          } else {
            setNotifications({ systemMessages: [], messages: [], importantMessages: [] });
            setUnreadCount(0);
          }
        });
    }
  };
  const handleNotificationClick = (type) => (event) => {
    if (type === 'important') {
      setAnchorElImportant(event.currentTarget);
    } else {
      setAnchorElRegular(event.currentTarget);
    }
  };

  const handleNotificationClose = (type) => () => {
    if (type === 'important') {
      setAnchorElImportant(null);
    } else {
      setAnchorElRegular(null);
    }
  };

  const handleReadAll = async (isImportant = false) => {
    try {
      // Get the notifications to clear
      const notificationsToClear = isImportant
        ? notifications.importantMessages
        : [...notifications.messages, ...notifications.systemMessages];
      if (notificationsToClear.length === 0) {
        return;
      }
      // Mark each notification as read individually to ensure they are properly cleared
      const clearPromises = notificationsToClear.map(async (notification) => {
        try {
          await dispatch(notificationsRead({
            user_id: userId,
            notification_id: notification.notification_id,
            token
          }));
          return true;
        } catch (error) {
          console.error('Error marking notification as read:', notification.notification_id, error);
          return false;
        }
      });

      // Wait for all notifications to be marked as read
      const results = await Promise.all(clearPromises);
      const successCount = results.filter(result => result).length;
      if (successCount > 0) {
        setNotifications(prevNotifications => {
          const updatedNotifications = { ...prevNotifications };
          if (isImportant) {
            updatedNotifications.importantMessages = [];
          } else {
            updatedNotifications.messages = [];
            updatedNotifications.systemMessages = [];
          }
          return updatedNotifications;
        });

        // Update unread count
        setUnreadCount(prevCount => {
          const newCount = Math.max(0, prevCount - successCount);
          return newCount;
        });

        // Close the menu if it's open
        if (isImportant) {
          setAnchorElImportant(null);
        } else {
          setAnchorElRegular(null);
        }
      } else {
      }
      fetchNotifications();
    } catch (error) {
    }
  };

  const handleActionCompleted = (notificationId) => {
    // Optimistically remove the notification from the state
    setNotifications(prev => ({
      ...prev,
      importantMessages: prev.importantMessages.filter(
        msg => msg.notification_id !== notificationId
      ),
      messages: prev.messages.filter(
        msg => msg.notification_id !== notificationId
      ),
    }));
    // Then, fetch the latest notifications from the server to ensure consistency
    fetchNotifications();
  };

  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
    navigate('/', { replace: true });
  };
  const changePassword = () => {
    setShowChangePassword(true);
  }
  //const [theme, setTheme] = useState('cosmo'); // Default theme

  // Change the theme when a new theme is selected
  // const switchTheme = (themeName) => {
  //   setTheme(themeName);
  //   const themeLink = document.getElementById('theme-link');
  //   themeLink.href = `https://stackpath.bootstrapcdn.com/bootswatch/4.5.0/${themeName}/bootstrap.min.css`;
  // };
  return (
    <>
      {/* Inject blinking bell CSS */}
      <style>{bellBlinkStyle}</style>
      {/* <link
        id="theme-link"
        rel="stylesheet"
        href={`https://stackpath.bootstrapcdn.com/bootswatch/4.5.0/${theme}/bootstrap.min.css`}
      /> */}
      <div className="d-flex justify-content-between align-items-center w-100 px-3 pmr-top-header">
        {/* Left: ACME Health logo */}
        <div
          className="d-flex align-items-center"
          style={{ height: '60px', overflow: 'hidden' }}
        >
          <img
            src={acmeHealthLogo}
            alt="ACME Health"
            className="w-auto"
            style={{ height: '150px', width: 'auto', objectFit: 'contain', cursor: 'pointer', filter: 'brightness(0)' }}
            onClick={() => props.onLogoClick && props.onLogoClick()}
          />
        </div>
        {/* <div className="mb-4">
          <label htmlFor="theme-selector" className="form-label">Select a Theme</label>
          <select
            id="theme-selector"
            className="form-select"
            onChange={(e) => switchTheme(e.target.value)}
          >
            <option value="cosmo">Cosmo</option>
            <option value="flatly">Flatly</option>
            <option value="darkly">Darkly</option>
            <option value="lumen">Lumen</option>
            <option value="paper">Paper</option>
            <option value="solar">Solar</option>
            <option value="cerulean">Cerulean</option>
          </select>
        </div> */}
        {/* Right: User dropdown + logout */}
        <div className="d-flex align-items-center justify-content-end">
          {/* Only show notifications for non-external users */}
          {!isExternalUser && (
            <>
              {/* Only show the bell if there are important notifications */}
              {notifications.importantMessages.length > 0 && (
                <div className="relative me-4">
                  <Tooltip title="Important Notifications">
                    <IconButton onClick={handleNotificationClick('important')} style={{ padding: 8 }}>
                      <Badge
                        badgeContent={notifications.importantMessages.length}
                        color="error"
                        overlap="circular"
                      >
                        <Bell
                          size={28}
                          className={
                            notifications.importantMessages.length > 0 ? 'blinking' : ''
                          }
                          style={{ color: 'var(--pmr-text-dark)' }}
                        />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                  <Menu
                    anchorEl={anchorElImportant}
                    open={Boolean(anchorElImportant)}
                    onClose={handleNotificationClose('important')}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                      style: {
                        minWidth: 400,
                        maxWidth: 500,
                        marginTop: 10,
                        maxHeight: 420,
                        borderRadius: 12,
                        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
                        overflow: 'hidden',
                        overflowX: 'hidden',
                      }
                    }}
                  >
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '16px 20px 8px 20px',
                      background: '#fff',
                      fontFamily: "'Inter', sans-serif",
                      fontWeight: 600,
                      fontSize: 16
                    }}>
                      <span>Important Notifications</span>
                      <span style={{
                        background: 'var(--pmr-bg-subtle)',
                        color: 'var(--pmr-primary)',
                        borderRadius: 12,
                        padding: '2px 12px',
                        fontFamily: "'Inter', sans-serif",
                        fontWeight: 600,
                        fontSize: 14,
                        minWidth: 48,
                        textAlign: 'center'
                      }}>
                        {notifications.importantMessages.length} New
                      </span>
                    </div>
                    <div style={{ borderBottom: '1px solid #f0f0f0', margin: '0 20px' }} />
                    <div className="notification-scroll-list">
                      {notifications.importantMessages.map((msg) => (
                        <MenuItem
                          key={msg.notification_id}
                          style={{ whiteSpace: "normal" }}
                          onClick={() => {
                            setSelectedImportantNotification(msg);
                            setShowImportantModal(true);
                            // Close the notification menu
                            setAnchorElImportant(null);
                          }}
                        >
                          <div className="w-100">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                              <div style={{ fontSize: 15, fontFamily: "'Inter', sans-serif", flexGrow: 1, paddingRight: '1rem' }} dangerouslySetInnerHTML={{ __html: msg.comments }} />
                              <IconButton
                                size="small"
                                style={{ padding: 0 }}
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  try {
                                    // Mark notification as read
                                    await dispatch(notificationsRead({
                                      user_id: userId,
                                      notification_id: msg.notification_id,
                                      token
                                    }));

                                    // Immediately update local state
                                    setNotifications(prev => ({
                                      ...prev,
                                      importantMessages: prev.importantMessages.filter(n => n.notification_id !== msg.notification_id)
                                    }));

                                    // If this was the last notification, close the menu
                                    if (notifications.importantMessages.length === 1) {
                                      setAnchorElImportant(null);
                                    }

                                    // Update unread count
                                    setUnreadCount(prevCount => Math.max(0, prevCount - 1));

                                    // Fetch fresh notifications in background
                                    fetchNotifications();
                                  } catch (error) {
                                    console.error("Error marking notification as read:", error);
                                  }
                                }}
                              >
                                ✕
                              </IconButton>
                            </div>
                            <div style={{ fontSize: 12, color: "#888", fontFamily: "'Inter', sans-serif", textAlign: 'right' }}>{msg.created_on}</div>
                          </div>
                        </MenuItem>
                      ))}
                    </div>
                    <MenuItem style={{ padding: 0, margin: 0 }}>
                      <Button
                        variant="contained"
                        fullWidth
                        style={{
                          fontFamily: "'Inter', sans-serif",
                          fontWeight: 600,
                          borderRadius: 6,
                          background: 'var(--pmr-btn-primary)',
                          color: '#fff',
                          marginTop: 8,
                          letterSpacing: 1,
                          textTransform: 'none'
                        }}
                        onClick={() => handleReadAll(true)}
                      >
                        Clear All Notifications
                      </Button>
                    </MenuItem>
                  </Menu>
                </div>
              )}

              {/* Regular Notifications Bell */}
              {(notifications.messages?.length > 0 || notifications.systemMessages?.length > 0) && (
                <div className="relative me-4">
                  {/* <Tooltip title="Notifications"> */}
                  <IconButton onClick={handleNotificationClick('regular')} style={{ padding: 8 }} title="Notifications">
                    <Badge
                      badgeContent={
                        notifications.messages.filter(m => !m.is_displayed).length +
                        notifications.systemMessages.filter(m => !m.is_displayed).length
                      }
                      color="error"
                      invisible={notifications.messages.filter(m => !m.is_displayed).length + notifications.systemMessages.filter(m => !m.is_displayed).length === 0}
                      overlap="circular"
                    >
                      <Bell size={28} style={{ color: '#222' }} />
                    </Badge>
                  </IconButton>
                  {/* </Tooltip> */}
                  <Menu
                    anchorEl={anchorElRegular}
                    open={Boolean(anchorElRegular)}
                    onClose={handleNotificationClose('regular')}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                      style: {
                        minWidth: 400,
                        maxWidth: 500,
                        marginTop: 10,
                        maxHeight: 420,
                        borderRadius: 12,
                        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
                        overflow: 'hidden',
                        overflowX: 'hidden',
                      }
                    }}
                  >
                    <MenuItem disabled>
                      <div className="d-flex justify-content-between w-100">
                        <span style={{ fontWeight: 600, fontFamily: "'Inter', sans-serif" }}>Notifications</span>
                        <span style={{ color: "var(--pmr-primary)", fontWeight: 600, fontFamily: "'Inter', sans-serif" }}>
                          {notifications.messages.length + notifications.systemMessages.length} New
                        </span>
                      </div>
                    </MenuItem>
                    <div className="notification-scroll-list">
                      {/* Regular Messages */}
                      {notifications.messages.map((msg) => (
                        <MenuItem key={msg.notification_id} style={{ whiteSpace: "normal" }}>
                          <div className="w-100">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                              <div
                                style={{ cursor: 'pointer', flexGrow: 1, paddingRight: '1rem' }}
                                onClick={() => {
                                  // Only show modal for family account notifications, not for regular shared reports
                                  if (msg.family_account_id) {
                                    setSelectedImportantNotification(msg);
                                    setShowImportantModal(true);
                                    // Close the notification menu
                                    setAnchorElRegular(null);
                                  }
                                  // For regular shared reports, just close the menu without removing notification
                                  else if (msg.share_id) {
                                    // Close the notification menu without removing the notification
                                    setAnchorElRegular(null);
                                  }
                                }}
                              >
                                <div style={{ fontSize: 15 }} dangerouslySetInnerHTML={{ __html: msg.comments }} />
                              </div>
                              <IconButton
                                size="small"
                                style={{ padding: 0 }}
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  try {
                                    // Mark notification as read
                                    await dispatch(notificationsRead({
                                      user_id: userId,
                                      notification_id: msg.notification_id,
                                      token
                                    }));

                                    // Immediately update local state
                                    setNotifications(prev => ({
                                      ...prev,
                                      messages: prev.messages.filter(n => n.notification_id !== msg.notification_id)
                                    }));

                                    // If this was the last notification, close the menu
                                    if (notifications.messages.length === 1) {
                                      setAnchorElRegular(null);
                                    }

                                    // Update unread count
                                    setUnreadCount(prevCount => Math.max(0, prevCount - 1));

                                    // Fetch fresh notifications in background
                                    fetchNotifications();
                                  } catch (error) {
                                    console.error("Error marking notification as read:", error);
                                  }
                                }}
                              >
                                ✕
                              </IconButton>
                            </div>
                            <div style={{ fontSize: 12, color: "#888", textAlign: 'right' }}>{msg.created_on}</div>
                          </div>
                        </MenuItem>
                      ))}

                      {/* System Messages Section */}
                      {notifications.systemMessages.length > 0 && (
                        <>
                          <MenuItem disabled style={{ background: "var(--pmr-bg-subtle)" }}>
                            <span style={{ fontWeight: 600, color: "var(--pmr-primary)" }}>System Notifications</span>
                          </MenuItem>
                          {notifications.systemMessages.map((msg) => (
                            <MenuItem key={msg.notification_id} style={{ whiteSpace: "normal" }}>
                              <div className="w-100">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                  <div
                                    style={{ cursor: 'pointer', flexGrow: 1, paddingRight: '1rem' }}
                                    onClick={() => {
                                      // Only show modal for family account notifications, not for regular shared reports
                                      if (msg.family_account_id) {
                                        setSelectedImportantNotification(msg);
                                        setShowImportantModal(true);
                                        // Close the notification menu
                                        setAnchorElRegular(null);
                                      }
                                      // For regular shared reports, just close the menu without removing notification
                                      else if (msg.share_id) {
                                        // Close the notification menu without removing the notification
                                        setAnchorElRegular(null);
                                      }
                                    }}
                                  >
                                    <div style={{ fontSize: 15 }} dangerouslySetInnerHTML={{ __html: msg.comments }} />
                                  </div>
                                  <IconButton
                                    size="small"
                                    style={{ padding: 0 }}
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      try {
                                        // Mark notification as read
                                        await dispatch(notificationsRead({
                                          user_id: userId,
                                          notification_id: msg.notification_id,
                                          token
                                        }));

                                        // Immediately update local state
                                        setNotifications(prev => ({
                                          ...prev,
                                          systemMessages: prev.systemMessages.filter(n => n.notification_id !== msg.notification_id)
                                        }));

                                        // If this was the last notification, close the menu
                                        if (notifications.systemMessages.length === 1) {
                                          setAnchorElRegular(null);
                                        }

                                        // Update unread count
                                        setUnreadCount(prevCount => Math.max(0, prevCount - 1));

                                        // Fetch fresh notifications in background
                                        fetchNotifications();
                                      } catch (error) {
                                        console.error("Error marking notification as read:", error);
                                      }
                                    }}
                                  >
                                    ✕
                                  </IconButton>
                                </div>
                                <div style={{ fontSize: 12, color: "#888", textAlign: 'right' }}>{msg.created_on}</div>
                              </div>
                            </MenuItem>
                          ))}
                        </>
                      )}
                    </div>
                    <MenuItem>
                      <Button
                        variant="contained"
                        fullWidth
                        style={{
                          fontWeight: 600,
                          borderRadius: 6,
                          background: 'var(--pmr-btn-primary)',
                          color: '#fff',
                          marginTop: 8,
                          textTransform: 'none'
                        }}
                        onClick={() => handleReadAll(false)}
                      >
                        Clear All Notifications
                      </Button>
                    </MenuItem>
                  </Menu>
                </div>
              )}
            </>
          )}
          {!isExternalUser && (
            <>
              <span className="me-4 fw-bold font-inter" style={{ fontFamily: "'Inter', sans-serif", fontSize: "14px", fontWeight: "500" }}>
                {userProfile.first_name} {userProfile.last_name}
              </span>
              {/* Hide profile section if hideProfile is true */}
              {!props.hideProfile && (
                <>
                  {/* Only show dropdown for non-external users */}
                  <Dropdown className="nav-item dropdown-user me-3" align="end">
                    <Dropdown.Toggle as="a" className="nav-link dropdown-user-link" title="Profile" style={{ textDecoration: 'none' }} bsPrefix="custom-dropdown-toggle">
                      <span className="avatar" style={{ position: 'relative', display: 'inline-block' }}>
                        <img
                          className="round"
                          src={userProfile.image_path}
                          height="40"
                          width="40"
                          style={{ borderRadius: 30, backgroundColor: "gray" }}
                          alt="profile"
                        />
                        <span
                          alt="online"
                          className="avatar-status-online-img"
                          style={{
                            position: 'absolute',
                            bottom: '0.1px',
                            right: '1px',
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            border: '2px solid white',
                            background: 'var(--pmr-success)',
                          }}
                        />
                      </span>

                    </Dropdown.Toggle>

                    {!isExternalUser && (
                      <Dropdown.Menu
                        aria-labelledby="navbarUserDropdown"
                        align="end"
                        className="dropdown-menu dropdown-menu-end w-auto"
                      >
                        <>
                          <Dropdown.Item href="/landing-page?menu=profile" onClick={(e) => { e.preventDefault(); props.showAccountSettings('profile'); }} style={{ fontFamily: "'Inter', sans-serif", fontSize: "14px" }}>
                            <FeatherIcon icon="user" className="me-2" /> Profile
                          </Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item href="/landing-page" onClick={(e) => { e.preventDefault(); changePassword(); }} style={{ fontFamily: "'Inter', sans-serif", fontSize: "14px" }}>
                            <FeatherIcon icon="settings" className="me-2" /> Change Password
                          </Dropdown.Item>
                        </>
                      </Dropdown.Menu>
                    )}
                  </Dropdown>
                </>
              )}
            </>
          )}
          {/* {isExternalUser && (
                <Dropdown.Item href="/landing-page" onClick={(e) => { e.preventDefault(); changePassword(); }} style={{ fontFamily: "'Inter', sans-serif", fontSize: "14px" }}>
                  <FeatherIcon icon="settings" className="me-2" /> Change Password
                </Dropdown.Item>
              )} */}


          {/* <span className="nav-link nav-link-style btn p-0" onClick={handleLogout} title="Logout">
            <img
              src={logout}
              alt="Logout"
              className="img-fluid"
              style={{ cursor: "pointer", width: 18, height: 20 }}
            />
          </span> */}

          <button className="nav-link btn nav-link-style bg-transparent border-0 text-custom-muted p-2" onClick={handleLogout} title="Logout">
            <FeatherIcon icon="log-out" className="cursor-pointer" size="17" style={{ color: 'var(--pmr-text)' }} />
          </button>

          {/*/ Navbar brand */}

        </div>
      </div>
      {/* Render the modal for important notification action */}
      <NotificationActionApproveReject
        show={showImportantModal}
        onHide={() => setShowImportantModal(false)}
        rowData={selectedImportantNotification}
        onActionComplete={handleActionCompleted}
      />
      {showChangePassword && (
        <ChangePassword
          onClose={() => setShowChangePassword(false)}
        />
      )}
      <PasskeyPostLoginPrompt />
    </>
  );
}

export default TopHeader;
